import { createActionString } from "../../../../../_shared";

export const UI_ERROR = createActionString("UI_ERROR", "UI");

export const setUIError = (key: string, value?: string) => ({
  type: UI_ERROR,
  key,
  value,
});
